import React, { Fragment, ReactNode } from 'react';

// Styles from the parent component
// Styles converted to Tailwind classes

export interface InfoRowProps {
  id?: string;
  label: ReactNode;
  value: ReactNode;
  showDivider?: boolean;
}

const InfoRow: React.FC<InfoRowProps> = ({ id, label, value, showDivider = true }) => (
  <Fragment key={id}>
    <div className='flex mt-10 mb-4 justify-between items-center'>
      <p className='text-10 xl:text-12 font-normal leading-[16px]'>{label}</p>
      <p className='text-12 xl:text-16 font-bold leading-18 xl:leading-[24px] text-black'>{value}</p>
    </div>
    {showDivider && <hr className='border-t border-neutral-20' />}
  </Fragment>
);

interface ShipmentInfoCardProps {
  icon: string;
  title: ReactNode;
  subtitle?: ReactNode;
  rows?: InfoRowProps[];
  testId?: string;
  className?: string;
  children?: ReactNode;
  actions?: ReactNode;
}

export const ShipmentInfoCard: React.FC<ShipmentInfoCardProps> = ({ icon, title, subtitle, rows, testId, className, actions, children }) => (
  <div className={`bg-white rounded-[10px] border border-[#DFDFDF] p-12 xl:p-16 mt-10 ${className || ''}`}>
    <div className='flex items-center gap-10'>
      <div>
        <img src={icon} alt='Icon' />
      </div>
      <div data-testid={testId} className='font-bold text-12 xl:text-16 leading-[18px] xl:leading-[20px] text-[#8A92A6]'>
        {title}
        {subtitle && <span className='text-10 xl:text-12 text-blue_grey-50 font-normal block'>{subtitle}</span>}
      </div>
      {actions}
    </div>

    {rows &&
      rows.map((row, index) => {
        // Use id if available, otherwise generate a stable key
        const key = row.id || `row-${index}`;

        return <InfoRow key={key} label={row.label} value={row.value} showDivider={index < rows.length - 1} />;
      })}

    {children}
  </div>
);

export default ShipmentInfoCard;
